import { render, staticRenderFns } from "./sectionWebProduct.vue?vue&type=template&id=ca4fb366&scoped=true&"
import script from "./sectionWebProduct.vue?vue&type=script&lang=js&"
export * from "./sectionWebProduct.vue?vue&type=script&lang=js&"
import style0 from "./sectionWebProduct.vue?vue&type=style&index=0&id=ca4fb366&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4fb366",
  null
  
)

export default component.exports